import { createTheme } from '@mui/material';

export const theme = createTheme({
  typography: {
    h1: {
      fontSize: '48px',
      lineHeight: '64px',
    },
    h2: {
      fontSize: '40px',
      lineHeight: '56px',
    },
    h3: {
      fontSize: '32px',
      lineHeight: '48px',
    },
    h4: {
      fontSize: '24px',
      lineHeight: '36px',
    },
  },
});
